<template>
  <div class="dash-sidebar">
    <!-- ==================== 设计师信息卡 ==================== -->
    <v-card flat class="side-card user-card" v-if="userInfo">
      <div class="user-top">
        <v-avatar size="54" class="user-avatar">
          <img :src="userInfo.avatar && userInfo.avatar != '' ? userInfo.avatar : require('@/assets/images/login/goodnull.png')" alt="">
        </v-avatar>
        <div class="user-meta">
          <p class="user-name">{{ userInfo.nickname }}</p>
          <span class="user-uid">
            <v-icon size="12" class="mr-1">mdi-creation</v-icon>UID {{ userInfo.id }}
          </span>
        </div>
      </div>
      <div class="user-contact">
        <span class="contact-item">
          <v-icon size="14" class="mr-1">mdi-phone-outline</v-icon>{{ userInfo.mobile }}
        </span>
        <span class="contact-item">
          <v-icon size="14" class="mr-1">mdi-email-outline</v-icon>{{ userInfo.email }}
        </span>
      </div>
    </v-card>

    <!-- ==================== 数据统计 ==================== -->
    <div class="stat-grid mt-4">
      <div class="stat-box">
        <b>{{ selfTotal || 0 }}</b>
        <span>{{ $t('我的模板') }}</span>
      </div>
      <div class="stat-box">
        <b>{{ buyedTotal || 0 }}</b>
        <span>{{ $t('已购模板') }}</span>
      </div>
    </div>

    <!-- ==================== 菜单导航 ==================== -->
    <v-card flat class="side-card menu-card mt-4">
      <p class="menu-label">{{ $t('工作台') }}</p>
      <div v-for="(item, i) in workGroup" :key="'w' + i" class="menu-item"
        :class="{ active: isActive(item.href) }" @click="topage(item, i)">
        <v-icon size="18" class="mr-3" :class="{ 'menu-icon-active': isActive(item.href) }">{{ item.icon }}</v-icon>
        <span class="menu-text">{{ $t(item.text) }}</span>
        <v-icon size="16" class="ml-auto" color="#C3CAD6">mdi-chevron-right</v-icon>
      </div>
      <p class="menu-label mt-4">{{ $t('记录') }}</p>
      <div v-for="(item, i) in recordGroup" :key="'r' + i" class="menu-item"
        :class="{ active: isActive(item.href) }" @click="topage(item, i)">
        <v-icon size="18" class="mr-3" :class="{ 'menu-icon-active': isActive(item.href) }">{{ item.icon }}</v-icon>
        <span class="menu-text">{{ $t(item.text) }}</span>
        <v-icon size="16" class="ml-auto" color="#C3CAD6">mdi-chevron-right</v-icon>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    buyedTotal: String,
    selfTotal: String,
  },
  data() {
    return {
      workGroup: [
        { text: '模板中心', icon: 'mdi-creation', href: '/user-index' },
        { text: '我的收益', icon: 'mdi-cash-multiple', href: '/income' },
      ],
      recordGroup: [
        { text: '购买记录', icon: 'mdi-shopping', href: '/buyed' },
        { text: '消费记录', icon: 'mdi-receipt', href: '/consume' },
      ],
      userInfo: null,
    }
  },
  mounted() {
    this.userInfo = this.$store.state.USERINFO;
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    topage(item) {
      this.$router.push({ path: item.href });
    }
  }
}
</script>

<style lang="scss" scoped>
.dash-sidebar {
  .side-card {
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.05);
  }

  /* 设计师信息卡 */
  .user-card {
    padding: 22px 20px 16px;

    .user-top {
      display: flex;
      align-items: center;
      gap: 14px;
      margin-bottom: 14px;
    }

    .user-avatar {
      border: 3px solid #fff;
      box-shadow: 0 0 0 2px rgba(115, 49, 255, 0.35), 0 6px 16px rgba(115, 49, 255, 0.18);
      flex-shrink: 0;
    }

    .user-name {
      font-size: 16px;
      font-weight: 700;
      color: #0F3460;
      margin-bottom: 2px;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 180px;
    }

    .user-uid {
      display: inline-flex;
      align-items: center;
      font-size: 12px;
      color: #7331FF;
      font-weight: 600;
      background: rgba(115, 49, 255, 0.08);
      border-radius: 12px;
      padding: 2px 10px;
    }

    .user-contact {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding-top: 12px;
      border-top: 1px dashed #EEF1F5;

      .contact-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #8A96A8;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  /* 数据统计 */
  .stat-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .stat-box {
      background: #fff;
      border: 1px solid #EEF1F5;
      border-radius: 14px;
      padding: 16px 12px;
      text-align: center;

      b {
        display: block;
        font-size: 24px;
        color: #7331FF;
        line-height: 1.2;
      }

      span {
        display: block;
        margin-top: 6px;
        font-size: 12px;
        color: #8A96A8;
      }
    }
  }

  /* 菜单导航 */
  .menu-card {
    padding: 16px 12px;

    .menu-label {
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 1px;
      color: #B0B9C7;
      text-transform: uppercase;
      margin: 0 8px 8px;
    }

    .menu-item {
      display: flex;
      align-items: center;
      padding: 11px 12px;
      border-radius: 10px;
      font-size: 14px;
      color: #4A5568;
      cursor: pointer;
      transition: background 0.2s, color 0.2s;
      margin-bottom: 2px;

      &:hover {
        background: rgba(115, 49, 255, 0.06);
        color: #7331FF;
      }

      &.active {
        background: rgba(115, 49, 255, 0.10);
        color: #7331FF;
        font-weight: 600;

        .menu-icon-active {
          color: #7331FF;
        }
      }

      .menu-text {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
      }
    }
  }
}
</style>
